﻿export function initOmzettenPage() {
    initializeRvpSelectionDropdown();
    initializeAlvSelectionDropdown();
    initializeConvertMethodDialogTitle();
    initializeChangeMortgageFormSubmit();
}

function initializeConvertMethodDialogTitle() {
    document.querySelectorAll('form[data-dialog-target="true"]').forEach(bindConvertMethodDialogTitle);
}

function bindConvertMethodDialogTitle(form) {
    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    const hasTravTitle = Boolean(form.dataset.dialogTitleTrav);
    const hasTramTitle = Boolean(form.dataset.dialogTitleTram);

    if (!hasTravTitle && !hasTramTitle) {
        return;
    }

    updateDialogTitleForForm(form);

    if (form.dataset.convertMethodTitleBound === "true") {
        return;
    }

    form.querySelectorAll('input[name="RvpMethodSelection.RvpMethod"], input[name="RvpMethod"]')
        .forEach(bindConvertMethodInputChange);

    form.dataset.convertMethodTitleBound = "true";
}

function bindConvertMethodInputChange(input) {
    if (!(input instanceof HTMLInputElement) || input.dataset.convertMethodTitleBound === "true") {
        return;
    }

    input.addEventListener("change", handleConvertMethodInputChange);
    input.dataset.convertMethodTitleBound = "true";
}

function handleConvertMethodInputChange(event) {
    const input = event.currentTarget;

    if (!(input instanceof HTMLInputElement)) {
        return;
    }

    const form = input.closest("form");

    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    updateDialogTitleForForm(form);
}

function updateDialogTitleForForm(form) {
    const selectedMethod =
        form.querySelector('input[name="RvpMethodSelection.RvpMethod"]:checked')?.value
        || form.querySelector('input[name="RvpMethod"]:checked')?.value;

    if (selectedMethod === "TRAV" && form.dataset.dialogTitleTrav) {
        form.dataset.dialogTitle = form.dataset.dialogTitleTrav;
        return;
    }

    if (selectedMethod === "TRAM" && form.dataset.dialogTitleTram) {
        form.dataset.dialogTitle = form.dataset.dialogTitleTram;
        return;
    }

    delete form.dataset.dialogTitle;
}

function initializeRvpSelectionDropdown() {
    document.querySelectorAll("#SelectedRvpConversion").forEach(bindSelectionDropdown);
}

function initializeAlvSelectionDropdown() {
    document.querySelectorAll("#SelectedAlvConversion").forEach(bindSelectionDropdown);
}

function bindSelectionDropdown(dropdown) {
    if (!(dropdown instanceof HTMLSelectElement) || dropdown.dataset.selectionBound === "true") {
        return;
    }

    updateSelectionHiddenFields(dropdown);
    dropdown.addEventListener("change", handleSelectionDropdownChange);

    dropdown.dataset.selectionBound = "true";
}

function handleSelectionDropdownChange(event) {
    const dropdown = event.currentTarget;

    if (!(dropdown instanceof HTMLSelectElement)) {
        return;
    }

    updateSelectionHiddenFields(dropdown);
}

function updateSelectionHiddenFields(dropdown) {
    const selectedValue = dropdown.value;

    if (!selectedValue) {
        return;
    }

    const form = dropdown.closest("form");

    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    const parts = selectedValue.split("|");
    const inputs = getConversionSelectionInputs(parts);

    if (!inputs) {
        return;
    }

    Object.entries(inputs).forEach(updateHiddenField.bind(null, form));
}

function updateHiddenField(form, entry) {
    const [name, value] = entry;
    const input = form.querySelector(`input[name="${name}"]`);

    if (!(input instanceof HTMLInputElement)) {
        return;
    }

    input.value = value;
}

function getConversionSelectionInputs(parts) {
    if (parts.length >= 3) {
        return {
            FixedInterestPeriod: parts[0],
            InterestType: parts[1],
            WithInterestMeans: parts.length > 2 ? parts[2] : "",
            MutationSpecificationId: parts.length > 3 ? parts[3] : ""
        };
    }

    if (parts.length === 1) {
        return {
            TechnicalProductName: parts[0]
        };
    }

    return null;
}

function initializeChangeMortgageFormSubmit() {
    const form = document.querySelector("#change-mortgage-form");

    if (!(form instanceof HTMLFormElement) || form.dataset.selectionValidationBound === "true") {
        return;
    }

    form.addEventListener("submit", handleChangeMortgageFormSubmit, true);

    form.querySelectorAll('[type="submit"]').forEach(bindChangeMortgageSubmitButton);

    form.dataset.selectionValidationBound = "true";
}

function bindChangeMortgageSubmitButton(button) {
    if (!(button instanceof HTMLElement) || button.dataset.selectionValidationBound === "true") {
        return;
    }

    button.addEventListener("click", handleChangeMortgageSubmitButtonClick, true);
    button.dataset.selectionValidationBound = "true";
}

function handleChangeMortgageFormSubmit(event) {
    const form = event.currentTarget;

    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    validateChangeMortgageSelection(event, form);
}

function handleChangeMortgageSubmitButtonClick(event) {
    const button = event.currentTarget;

    if (!(button instanceof HTMLElement)) {
        return;
    }

    const form = button.closest("form");

    if (!(form instanceof HTMLFormElement)) {
        return;
    }

    validateChangeMortgageSelection(event, form);
}

function validateChangeMortgageSelection(event, form) {
    if (hasChangeMortgageSelection(form)) {
        hideChangeMortgageSelectionError();
        return;
    }

    blockChangeMortgageSubmission(event);
    showChangeMortgageSelectionError();
}

function hasChangeMortgageSelection(form) {
    return form.dataset.hasSelection === "true";
}

function showChangeMortgageSelectionError() {
    const error = document.querySelector("#change-mortgage-selection-error");

    if (!(error instanceof HTMLElement)) {
        return;
    }

    error.hidden = false;
    error.scrollIntoView({ behavior: "smooth", block: "nearest" });
}

function hideChangeMortgageSelectionError() {
    const error = document.querySelector("#change-mortgage-selection-error");

    if (!(error instanceof HTMLElement)) {
        return;
    }

    error.hidden = true;
}

function blockChangeMortgageSubmission(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
}

document.addEventListener("dialog:contentready", initOmzettenPage);